export const getDeleteAndGetCookieSource = () => `
        (function(){var now = new Date();
            now.setTime(now.getTime() + 1 * 3600 * 1000 * 24 * 365);
            delete_cookie();
             
            function delete_cookie() {
                if ( !getCookie('cleared-onetrust-cookies')) {
                document.cookie = "OptanonAlertBoxClosed" + "=" + "; path=/" + "; domain=.www.dazn.com" + '; expires=Thu, 01 Jan 1970 00:00:01 GMT';
                document.cookie = "OptanonConsent" + "=" + "; path=/" + "; domain=.www.dazn.com" + '; expires=Thu, 01 Jan 1970 00:00:01 GMT';
                }                         
                document.cookie = "cleared-onetrust-cookies" + "=" + "; path=/" + "; domain=.www.dazn.com" + "; expires="+now;
            }
             
            function getCookie( cookieName ) {
                var value = '; ' + document.cookie;
                var parts = value.split( '; ' + cookieName + '=' );    
                if ( parts.length == 2 ) {
                return true;
                }
            }
            })();
        `;
